var fs_url_params = {}
var fs_browser_id = ''

getUrlParam = function(name){
      var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
      if (results==null) {
        return null;
      }
      return decodeURI(results[1]) || 0;
    };

function register_staff(){
  staff_name = getUrlParam('fs_source_staff')
  if (staff_name){
    setCookie("fs_self_id", staff_name, 365)
  }
}

function generatePass() {
    let pass = '';
    let str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
        'abcdefghijklmnopqrstuvwxyz0123456789@#$';

    for (let i = 1; i <= 18; i++) {
        let char = Math.floor(Math.random()
            * str.length + 1);

        pass += str.charAt(char)
    }

    return pass;
}

// Function to generate a unique ID with timestamp
function generateUniqueId() {
    const now = new Date();
    return `id-${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}-`
        + `${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}-`
        + `${Math.random().toString(36).substr(2, 9)}`;
}

function trackProductPageView(){
  // console.log('running trackProductPageView()')
  // Ensure a unique ID exists in cookies
  if (product_id || collection_id){
    let uniqueId = getCookie("fs_self_id");
    if (!uniqueId) {
        uniqueId = generateUniqueId();
        setCookie("fs_self_id", uniqueId, 365); // Save for 7 days
    }
  let payload = {
      user_id: uniqueId,
      datetime: new Date().toISOString()
  }

  if (product_id){
    payload['product_id'] = product_id
    } else if (collection_id) {
    payload['collection_id'] = collection_id
    }
  
    fetch('https://fs-item-view-tracking-541962859153.us-central1.run.app', {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
      })
      .then(response => response.text)
      // .then(data => console.log("Success:", data))
      // .catch(error => console.error("Error:", error))
  }
}

function register_id(){
  let id = getCookie("fs_self_id")
  let today = new Date()
  let today_str = today.getUTCFullYear().toString() + today.getUTCMonth().toString() + today.getUTCDate().toString()
  if (!id){
    id = generateUniqueId()
    // id = today_str + "___" + id
    setCookie('fs_self_id', id, 300)
  }
}

function validate_postcode_format(x){
  if (isNaN(x) || x < 10000 || x > 99999) {
    return false;
  } else {
    return x;
  }
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

function fs_track_post(input){
  //   console.log('session started')
//   console.log(JSON.stringify(input))
  $.ajax({
    type: "POST",
    url: 'https://l.flowersugar.com/tracking/session/',
    data: JSON.stringify(input),
    success: function(d)
    {
      if (d.status == 'success')
      {
        //           console.log(d)
        fs_browser_id = d.browser_id;
        setCookie('fs_browser_id', fs_browser_id, 3650)
        //           console.log(fs_browser_id)
        //           console.log("cookie_set")
        setCookie('fstrack_last_updated', Date.now(), 3650)

        //           ga('set', 'userId', fs_browser_id);
        //           gtag('config', 'G-PWXYXEK3FK', {
        //             'user_id': fs_browser_id
        //           });

      }
    },
    timeout: 10000,
    error: function(jqXHR, textStatus, errorThrown) {
      if(textStatus==="timeout") {
        //do something on timeout
      } 
    }});
}

function fs_track_session(input){
  var prev_track_time = getCookie('fs_track_time')

  if (prev_track_time == ""){
    var track_time = new Date().getTime()
    setCookie('fs_track_time',track_time,1)

    // fs_track_post(input) DISABLED ON 3 AUG 2023

  } 
  else{
    var prev_track_time_int = parseInt(prev_track_time)
    var track_time_lapse = new Date() - new Date(prev_track_time_int)
    if (track_time_lapse > 5000){
      // fs_track_post(input) DISABLED ON 3 AUG 2023
    }

  }


};

function fs_track_cart(cart){
  var cart_data = cart;
  cart_data.browser_id = fs_browser_id;
  cart_data.url = window.location.href.split('flowersugar.com')[1]
  $.ajax({
    type: "POST",
    url: 'https://l.flowersugar.com/tracking/cart/',
    data: JSON.stringify(cart_data),
    dataType: "json",
    success: function(d)
    {
      if (d.status == 'success')
      {
        //         console.log('cart tracked')
      }
    },
    timeout: 10000,
    error: function(jqXHR, textStatus, errorThrown) {
      if(textStatus==="timeout") {
        //do something on timeout
      } 
    }});
}

function initiate_fs_track(){
  $.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
      return null;
    }
    return decodeURI(results[1]) || 0;
  };

  fs_url_params = {
    url: window.location.href.split('?')[0],
    fs_browser_id: null,
    fs_referrer: document.referrer,
    fs_source : $.urlParam('utm_source'),
    fs_medium : $.urlParam('utm_medium'),
    fs_campaign : $.urlParam('utm_campaign'),
    fs_content : $.urlParam('utm_content'),
    fs_search_keyword : $.urlParam('utm_keyword'),
    fs_search_adposition : $.urlParam('ad_position'),
    fs_search_creative : $.urlParam('creative'),
    fs_search_location : $.urlParam('location'),
    fs_order_number : $.urlParam('order_number'),
    fs_gclid : $.urlParam('gclid'),
    fs_fbclid : $.urlParam('fbclid'),
    fs_placement : $.urlParam('placement'),
  };

  for (var key in fs_url_params){
    if (fs_url_params[key] == null && getCookie(key) != ""){
      fs_url_params[key] = getCookie(key)
    };

    if (fs_url_params[key] != null){
      setCookie(key, fs_url_params[key], 365);
    }

    if (fs_url_params[key] == null){
      fs_url_params[key] = ""
    };

  }

  var last_updated = getCookie('fstrack_last_updated')
  if (getCookie('fs_browser_id') != ""){
    fs_browser_id = getCookie('fs_browser_id');
    fs_url_params['fs_browser_id'] = fs_browser_id;
  }

  //   'https://postgresql-287613.uc.r.appspot.com/tracking/session/'

  //   fs_track_session(fs_url_params)


  if (last_updated == ""){
    fs_track_session(fs_url_params) 
  } 

  else if ((Date.now() - parseInt(last_updated)) > (3*60*1*1000)){
    fs_track_session(fs_url_params) 
  };
}

function initiate_whatsapp_btn(){
  let pathname = window.location.pathname
  let product_handle_regex = /\/products\/(.*?)/i;
  let product_url_match = product_handle_regex.exec(pathname)
  let product_handle = ''

  if (product_url_match){
    product_handle = pathname.slice(product_url_match.index+10,pathname.length)
  }

  
  let whatsapp_btn = document.getElementById("whatsapp_btn_holder");

  let whatsapp_btn_href = ""
  let whatsapp_btn_href_alt = ""

  if (getCookie('fs_self_id') != ""){
    fs_self_id = getCookie('fs_self_id')
    whatsapp_btn_href = `
https://api.whatsapp.com/send?phone=60183438363&text=Hi%20Flower%20Sugar!%20I%20would%20like%20to%20know%20more%20about%20your%20products%20%20%5Bref:%20${fs_self_id};%20${product_handle}%5D
`
        whatsapp_btn_href_alt = `
https://api.whatsapp.com/send?phone=60183438363&text=Hi%20Flower%20Sugar!%20I%20would%20like%20to%20know%20more%20about%20your%20products%20%20%5Bref:%20${fs_self_id};%20${product_handle}%5D
`
  } else
  {
    whatsapp_btn_href = `
https://api.whatsapp.com/send?phone=60183438363&text=Hi%20Flower%20Sugar!%20I%20would%20like%20to%20know%20more%20about%20your%20products%20%5Bref:%20${product_handle}%5D
`
        whatsapp_btn_href_alt = `
https://api.whatsapp.com/send?phone=60183438363&text=Hi%20Flower%20Sugar!%20I%20would%20like%20to%20know%20more%20about%20your%20products%20%5Bref:%20${product_handle}%5D
`
  }
  whatsapp_btn.setAttribute("href", whatsapp_btn_href);
  // whatsapp_btn.setAttribute("id", "whatsapp_btn_holder_2");

  function whatsapp_click_2() {
    console.log("tag 2 fired");
    return gtag_report_conversion('https://wa.me/60183438363')
  }

    $('#whatsapp_btn_holder').click(function(){
      track_whatsapp_btn_click(whatsapp_btn_href)
    })
  
}

function FSshowNotice(message = '', bottom_position = '20vh', width = 20, background_color = "rgb(231, 215, 143)", duration = 3) {
    let back = 'rgb(211 231 143 / 68%)'
    let left = (100 - width) / 2
    let width_val = width + "%"
    let left_val = left + "%"
    let notice_period = duration * 1000 //miliseconds
    let notice_fade_period = notice_period - 1000
    const notice = document.createElement('div');
    notice.textContent = message;
    notice.style.position = "fixed";
    notice.style.bottom = bottom_position;
    notice.style.backgroundColor = background_color;
    notice.style.color = "rgb(0, 0, 0)";
    notice.style.padding = "10px 20px";
    notice.style.borderRadius = "8px";
    notice.style.fontSize = "14px";
    notice.style.opacity = "1";
    notice.style.transition = "opacity 1s";
    notice.style.width = width_val;
    notice.style.left = left_val;
    notice.style.zIndex = "1000";
    notice.style.textAlign = "center";
  
    document.body.appendChild(notice);

  
    // After 2 seconds, start fading out
    setTimeout(() => {
      notice.style.opacity = '0';
    }, notice_fade_period);
  
    // After 3 seconds, remove the element
    setTimeout(() => {
      document.body.removeChild(notice);
    }, notice_period);
  }

$(document).ready(function(){
  initiate_fs_track();

  if (init_whatsapp_btn){
    initiate_whatsapp_btn();
  }
  
  register_staff()
  register_id();
  trackProductPageView();

})